import { render, staticRenderFns } from "./scoreHistory.vue?vue&type=template&id=09a41520&"
import script from "./scoreHistory.vue?vue&type=script&lang=js&"
export * from "./scoreHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports